import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { LocalRepoListComponent } from "./components/local-repo-list/local-repo-list.component";
import { LocalRepoRoutingModule } from "./local-repo-routing.module";
import { AddLocalRepoComponent } from "./modals/add-local-repo/add-local-repo.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgxSpinnerModule } from "ngx-spinner";
import { ResizableModule } from "../../core/directive/resizable/resizable.module";
import { SelectRepoUserComponent } from "./modals/select-repo-user/select-repo-user.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AngularSplitModule } from "angular-split";
import { RepoAdvanceViewComponent } from "./components/repo-advance-view/repo-advance-view.component";
import { MatTabsModule } from "@angular/material/tabs";
@NgModule({
  declarations: [
    LocalRepoListComponent,
    AddLocalRepoComponent,
    SelectRepoUserComponent,
    RepoAdvanceViewComponent,
  ],
  imports: [
    CommonModule,
    AngularSplitModule,
    ReactiveFormsModule,
    FormsModule,
    LocalRepoRoutingModule,
    BrowserModule,
    MatFormFieldModule,
    MatInputModule,
    NgxSpinnerModule,
    ResizableModule,
    MatCheckboxModule,
    MatTabsModule,
  ],
})
export class LocalRepoModule {}
